<script setup lang="ts">
/** Ortak birincil eylem dugmesi — dort adimin "Devam et / Oturum ac / Sec /
 * Ac" dugmeleri ayni gorsel + yukleniyor davranisini paylasir. */
import { useId } from 'vue'

defineOptions({ inheritAttrs: false })
const reasonId = useId()
defineProps<{
  readonly label: string
  readonly loading?: boolean
  readonly disabled?: boolean
  readonly disabledReason?: string
  readonly type?: 'button' | 'submit'
}>()

defineEmits<{ click: [] }>()
</script>

<template>
  <button
    v-bind="$attrs"
    :type="type ?? 'button'"
    class="fw-auth-button"
    :disabled="disabled === true || loading === true"
    :aria-disabled="disabledReason && (disabled || loading) ? true : undefined"
    :aria-describedby="disabledReason && (disabled || loading) ? reasonId : undefined"
    @click="$emit('click')"
  >
    {{ label }}
  </button>
  <p
    v-if="disabledReason && (disabled || loading)"
    :id="reasonId"
    class="fw-auth-button__reason"
    role="status"
  >
    {{ disabledReason }}
  </p>
</template>

<style scoped>
.fw-auth-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: var(--fw-primary);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin-top: 18px;
}

.fw-auth-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
